/**
 * Derives user initials from fullName and firstName.
 * Uses firstName to determine where the last name starts in fullName,
 * matching the backend ParseName behavior.
 */
export function getInitials(fullName?: string, firstName?: string): string[] {
  if (!fullName) return [];

  const firstInitial = firstName?.[0];
  const lastName = firstName ? fullName.replace(firstName, '').trim() : '';
  const lastInitial = lastName?.[0];

  return [firstInitial, lastInitial].filter(Boolean) as string[];
}
